import { render } from "./productionPoint.vue?vue&type=template&id=8ccc1846&scoped=true&ts=true"
import script from "./productionPoint.vue?vue&type=script&lang=ts"
export * from "./productionPoint.vue?vue&type=script&lang=ts"

import "./productionPoint.vue?vue&type=style&index=0&id=8ccc1846&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccc1846"]])

export default __exports__